import { Suspense, ReactNode } from 'react'

import { LazyErrorBoundary } from 'components/LazyErrorBoundary/LazyErrorBoundary'
import { observer } from 'mobx-react-lite'

interface Props {
  component: ReactNode
  overrideFallback?: ReactNode
}

const LazyComponentWrapper = ({ component, overrideFallback }: Props) => {
  const fallback = <div />

  return (
    <LazyErrorBoundary>
      <Suspense fallback={overrideFallback || fallback}>{component}</Suspense>
    </LazyErrorBoundary>
  )
}

interface MobxProps extends Props {
  condition: () => boolean
}

const LazyMobxComponentWrapper = observer(({ condition, component, overrideFallback }: MobxProps) =>
  condition() ? <LazyComponentWrapper component={component} overrideFallback={overrideFallback} /> : <></>,
)

export { LazyComponentWrapper, LazyMobxComponentWrapper }
